import axios from 'axios'
import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
/* name should be camel case in all function */
function getGenerateOTP(uannumber,userID) {
  const BaseUrl = ApiValues.EPFGenerateOTP + `uannumber=${uannumber}&userID=${userID}`


  //AsOnDate

  // return fetch(BaseUrl, {
  //   method: 'POST',
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json',
  //   },
  // })
  //   .then((response) => response.json())
  //   .then((responseJson) => {
  //     return responseJson
  //   })
  //   .catch((error) => {
  //     return { "status": "F", "mes  sage": labels.messages.apierror }
  //   });
  return Networking.GetApi(BaseUrl,"").then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }

      // 
    });

}
export default getGenerateOTP
